module.exports = __webpack_public_path__ + "img/partner.b94cf602.png";